import { motion } from 'framer-motion';
import { servicesData } from '../assets/data';
import { Home, Leaf, Building2, Lightbulb, Sofa, Sun } from 'lucide-react';

const Services = () => {
  // Mappage des icônes Lucide avec des noms valides
  const iconComponents = {
    home: Home,
    tree: Leaf,         // Utilise Leaf comme alternative à Tree
    building: Building2, // Building2 est le nom correct dans lucide-react
    lightbulb: Lightbulb,
    couch: Sofa,         // Sofa est l'icône la plus proche de Couch
    sun: Sun
  };

  return (
    <section className="py-24 min-h-screen relative overflow-hidden bg-white">
      {/* Vague décorative en haut */}
      <div className="absolute top-0 left-0 w-full h-24 pointer-events-none select-none z-0">
        <svg viewBox="0 0 1200 120" className="w-full h-full">
          <path d="M0,0V7.23C0,65.52,268.63,112.77,600,112.77S1200,65.52,1200,7.23V0Z" className="fill-amber-100" />
          <path d="M0,0V15.81C0,72.92,268.63,118.27,600,118.27S1200,72.92,1200,15.81V0Z" className="fill-orange-100" />
        </svg>
      </div>
      <div className="container mx-auto px-5 relative z-10">
        <div className="text-center mb-20 relative">
          <h2 className="text-3xl md:text-4xl font-bold mb-5 text-dark relative">
            Nos Services
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Découvrez notre gamme complète de services de décoration
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesData.map((service, index) => {
            const IconComponent = iconComponents[service.icon] || Home;
            
            return (
              <motion.div 
                key={service.id}
                className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition-all relative overflow-hidden group h-full flex flex-col"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                {/* Image visible en permanence avec effet de zoom */}
                <motion.div 
                  className="relative h-48 overflow-hidden rounded-t-2xl mb-6 flex-shrink-0"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                >
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-full object-cover absolute inset-0"
                  />
                  {/* Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-70 group-hover:opacity-50 transition-opacity duration-300" />
                </motion.div>
                
                {/* Contenu de la carte */}
                <div className="relative z-10 px-4 pb-4 flex-grow flex flex-col items-center">
                  {/* Icône circulaire avec Lucide */}
                  <div className="w-16 h-16 mb-4 -mt-10 flex items-center justify-center bg-gradient-to-r from-amber-500 to-orange-500 rounded-full text-white shadow-lg z-20 relative">
                    <IconComponent className="w-8 h-8" />
                  </div>
                  
                  {/* Titre et description */}
                  <h3 className="text-xl font-semibold mb-3 text-center text-gray-800 group-hover:text-amber-600 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 text-center leading-relaxed flex-grow">
                    {service.description}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;